import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function InfoTabs({ userId }) {
  const { t } = useTranslation();
  const [userInfo, setUserInfo] = useState(null);
  const [activeTab, setActiveTab] = useState("bio");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) return;
    setLoading(true);
    const fetchUser = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/users.php?userid=${userId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        setUserInfo(res.data.user);
      } catch (e) {
        setUserInfo(null);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [userId]);

  if (loading) return <div>載入中...</div>;
  if (!userInfo) return <div>找不到用戶資料</div>;

  return (
    <div className=" flex flex-col gap-4">
      <div className=" flex flex-row rounded-t-lg  mt-2 border-b border-orange-200">
        <button
          className={` bg-orange-500 hover:bg-orange-300 text-white px-4 py-2 rounded-t mr-1 ${
            activeTab === "bio" ? "bg-orange-300 " : ""
          }`}
          onClick={() => setActiveTab("bio")}
        >
          {t("register.Bio")}
        </button>
        <button
          className={` bg-orange-500 hover:bg-orange-300 text-white px-4 py-2 rounded-t  mr-1 ${
            activeTab === "achievement" ? "bg-orange-300" : ""
          }`}
          onClick={() => setActiveTab("achievement")}
        >
          {t("register.achievement")}
        </button>
      </div>
      <div className="border-b border-orange-200 ">
        <div className="max-h-150 overflow-y-auto p-2">
          {activeTab === "bio" && (
            <div>
              {(userInfo.bio || "無資料").split("\n").map((line, idx) => (
                <span key={idx}>
                  {line}
                  <br />
                </span>
              ))}
            </div>
          )}
          {activeTab === "achievement" && (
            <div>
              {userInfo.achievement ? (
                <div>
                  {(userInfo.achievement || "無資料")
                    .split("\n")
                    .map((line, idx) => (
                      <span key={idx}>
                        {line}
                        <br />
                      </span>
                    ))}
                </div>
              ) : (
                <div>無成績資料</div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default InfoTabs;
